import Api from "./Api";

export default {
  getScreenDetails(payload) {
    return Api().get("/api/users:", payload);
  },
  getSeatLayout(payload) {
    return Api(payload).get("screen_layouts/" + payload.screenID, payload);
  },
  editSeatLayout(payload) {
    return Api(payload).put("screen_layouts/" + payload.screen_id, payload);
  },
  getSeatScreenType(payload) {
    return Api(payload).get(
      "/api/admin/tablelist/screen_seat_type?sst_is_active=Y&screen_id=" +
        payload.screenID,
      payload
    );
  },
  GetActiveScreens(payload) {
    return Api().post("/active-list/screens", payload);
  },
  submitBrokenSeatLayout(payload) {
    return Api(payload).post("/submit_broken_seats", payload);
  },
  manageBrokenSeatLayout(payload) {
    return Api(payload).post("/manage_broken_seats", payload);
  },
  checkBookedSeatsForBrokenUpdate(payload) {
    return Api(payload).post("/check_for_booked_seats", payload);
  },
};



// WEBPACK FOOTER //
// ./src/services/ScreenService.js